import React, { useRef, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import InsightsIcon from '@mui/icons-material/Insights';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { ReactComponent as Logo } from '../../assets/Logo1.svg';

import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';

const iconMap = {
  dashboard: <DashboardIcon fontSize="medium" />,
  'user-world': <PeopleIcon fontSize="medium" />,
  'corporate-portal': <BusinessIcon fontSize="medium" />,
  'subscriber-world': <PeopleIcon fontSize="medium" />,
  'Admin-Insights': <InsightsIcon fontSize="medium" />,
  insights: <InsightsIcon fontSize="medium" />,
  Calendar: <CalendarMonthIcon fontSize="medium" />,

  "My-World" : <AssignmentOutlinedIcon fontSize="medium" />,
  "Blog" : <AutoStoriesIcon fontSize="medium" />,

};

const AdminSidebar = ({ activeSection, setActiveSection, sections }) => {
  const [activePos, setActivePos] = useState({ top: 0, height: 0 });
  const itemRefs = useRef([]);
  const history = useHistory();

  // Map sections to routes
  const sectionRoutes = {
    dashboard: '/admin',
    'user-world': '/admin/userworld',
    'corporate-portal': '/admin/corporate',
    'subscriber-world': '/admin/subscribers',
    'Admin-Insights': '/admin/admininsights',
    insights: '/admin/insights',
    Calendar: '/admin/calendar',
    
    "My-World": "/projects",
    "Blog": "/blogs",
  };

  useEffect(() => {
    const idx = sections.findIndex((item) => item.value === activeSection);
    if (itemRefs.current[idx]) {
      const rect = itemRefs.current[idx].getBoundingClientRect();
      const parentRect = itemRefs.current[0].parentNode.getBoundingClientRect();
      setActivePos({ top: rect.top - parentRect.top, height: rect.height });
    }
  }, [activeSection, sections]);

  const handleClick = (section) => {
    setActiveSection(section.value);
    history.push(sectionRoutes[section.value] || '/admin');
  };

  return (
    
    <div className="flex flex-col h-full">
      <nav className="flex-1 p-4 space-y-4"> {/* Added space-y-2 for gap */}
        {sections.map((item, idx) => (
          <button
            key={item.value}
            ref={(el) => (itemRefs.current[idx] = el)}
            className={`flex items-center gap-3 py-3 px-4 text-sm rounded-lg font-semibold transition-all duration-300 relative z-10 w-full text-left ${
              activeSection === item.value
                ? 'text-blue-700 bg-blue-50 font-bold shadow-sm'
                : 'text-gray-800 hover:bg-blue-50 hover:text-blue-600'
            }`}
            onClick={() => handleClick(item)}
            aria-label={`Go to ${item.key}`}
          >
            {iconMap[item.value] || <DashboardIcon fontSize="medium" />}
            {item.key}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default AdminSidebar;